/* eslint-disable no-class-assign */
import {
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Input,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Switch,
  TextField,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Step from "@material-ui/core/Step";
import StepContent from "@material-ui/core/StepContent";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps as AgentAction } from "./../redux/agent";
import { mapActionsToProps } from "./../redux/campaigns";
import { mapActionsToProps as phoneNumberAction } from "./../redux/cloudPBX/phoneNumber";
import { mapActionsToProps as stageAction } from "./../redux/miniCrm/stage";
import { mapActionsToProps as formAction } from "./../redux/telesale/form";
import Dialog from "./Dialog";
import SnackbarContent from "./SnackbarContentWrapper";

const styles = (theme) => ({
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  button: {
    margin: theme.spacing.unit * 3,
  },
  actionsContainer: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: -theme.spacing.unit * 2,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  form: {
    width: "100%",
  },
  header: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit * 6,
    top: theme.spacing.unit * 6,
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.header} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function deduplicate(arr) {
  let isExist = (arr, x) => arr.indexOf(x) > -1;
  let ans = [];
  arr.forEach((element) => {
    if (!isExist(ans, element)) ans.push(element);
  });
  return ans;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, that) {
  return {
    fontWeight: that.state.name
      ? that.sate.name.indexOf(name) === -1
        ? that.props.theme.typography.fontWeightRegular
        : that.props.theme.typography.fontWeightMedium
      : null,
  };
}

class CampaignDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      number: 0,
      checkSelect: true,
      stages: {
        ni: true,
        dnd: true,
      },
      stageId: [],
      campaign: [],
      campaignIds: [],
      check: false,
      allowDuplicate: true,
      checkForm: true,
      allowRecall: false,
      checkRecallSelect: true,
      selectAgent: true,
      listAgentInCampaign: [],
      agentId: "",
    };
  }

  async componentDidMount() {
    await this.props.getAllCampaigns();
    await this.props.getListPhoneNumber();
    await this.props.getListStage();
    this.props.getListAgent("createdAt DESC", 999);
    this.props.getListForm(null, null, null, null, null, { query: "all" });
  }

  handleChange = (name) => {
    const { listCampaign } = this.props;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;

    return (e) => {
      this.setState(
        {
          [name]: e.target.value,
          checkSelect: false,
        },
        () => {
          if (name === "id") {
            if (listCampaignResult) {
              const campaign = listCampaignResult.find(
                (item) => item.id === e.target.value
              );
              if (campaign) {
                this.setState({ listAgentInCampaign: campaign.listAgent });
              }
            }
            // this.props.getListForm(null, null, null, { where: { campaignId: this.state.id } }); //OCX-231
          }
        }
      );
    };
  };

  handleChangeSwitch = (name) => (event) => {
    this.setState({ [name]: event.target.checked, checkSelect: false });
  };

  handleChangeSwitchRecall = (name) => (event) => {
    this.setState({
      [name]: event.target.checked,
      checkRecallSelect: false,
      allowDuplicate: false,
    });
  };

  handleSubmit = () => {
    const {
      id,
      number,
      stages,
      formId,
      stageId,
      campaignIds,
      campaign,
      agentAllocationType,
      allowRecall,
      allowDuplicate,
    } = this.state;
    let dataStage = [];
    const { listStage } = this.props;
    const listStageResult =
      typeof listStage === "object"
        ? Object.keys(listStage).map((key) => listStage[key])
        : listStage;
    if (listStageResult) {
      listStageResult.find((i) => {
        if (stages[i.id] === true) {
          stageId.push(i.id);
        }
        if (stages[i.id] === false) {
          stageId.splice(stageId.indexOf(i.id), 1);
        }
      });
    }
    const type =
      this.props.bigData === true
        ? "data"
        : this.props.type === "contact"
        ? "contact"
        : this.props.campaigns == undefined
        ? "file"
        : this.props.type && allowRecall == true
        ? "ilnp"
        : "li";

    dataStage = deduplicate(stageId);
    if (campaign) {
      campaign.map((i) => {
        campaignIds.push(i.id);
      });
    }
    if (allowDuplicate == false) {
      dataStage = null;
    }

    if (this.props.campaigns == true) {
      this.props.campaignConfig(
        id,
        this.props.contactFileId,
        number,
        agentAllocationType,
        allowDuplicate,
        dataStage,
        formId,
        type,
        campaignIds,
        { agentId: this.state.agentId }
      );
    } else if (this.props.bigData == true) {
      this.props.campaignConfig(
        id,
        this.props.contactFileId,
        number,
        agentAllocationType,
        allowDuplicate,
        dataStage,
        formId,
        type,
        campaignIds,
        this.props.filterData,
        { limit: this.state.limit },
        { agentId: this.state.agentId }
      );
    } else {
      this.props.campaignConfig(
        id,
        this.props.contactFileId,
        number,
        agentAllocationType,
        allowDuplicate,
        dataStage,
        formId,
        type,
        campaignIds,
        this.props.filterData,
        { agentId: this.state.agentId }
      );
    }
    this.setState({
      checkSelect: true,
      activeStep: 0,
    });
  };

  handleNext = () => {
    this.setState((state) => ({
      activeStep: state.activeStep + 1,
      checkSelect: true,
    }));
  };

  handleBack = () => {
    this.setState((state) => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleCheckStage = (name) => {
    return (e) => {
      this.setState({
        stages: {
          ...this.state.stages,
          [name]: e.target.checked,
        },
      });
    };
  };

  handleChangeCampaignIds = (e) => {
    this.setState({
      campaign: e.target.value,
      checkSelect: false,
    });
  };

  handleClose() {
    this.props.openModal && this.props.openModalNotification();
  }

  handleChangeAgent = (name) => {
    return (e) => {
      this.setState({ agentId: e.target.value });
    };
  };

  getStepContent = (step) => {
    const {
      id,
      number,
      formId,
      agentAllocationType,
      allowDuplicate,
      allowRecall,
      checkForm,
    } = this.state;
    const {
      classes,
      listFormTelesale,
      listPhoneNumber,
      listCampaign,
      listStage,
    } = this.props;
    const listFormTelesaleResult =
      typeof listFormTelesale === "object"
        ? Object.keys(listFormTelesale).map((key) => listFormTelesale[key])
        : listFormTelesale;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    const listStageResult =
      typeof listStage === "object"
        ? Object.keys(listStage).map((key) => listStage[key])
        : listStage;
    switch (step) {
      case 0:
        return (
          <TextField
            margin="normal"
            variant="outlined"
            className={classes.input}
            id="outlined-select-currency"
            select
            placeholder="Chọn chiến dịch"
            value={id}
            onChange={this.handleChange("id")}
            name="id"
            fullWidth>
            {listCampaignResult
              ? listCampaignResult.map((item, key) => {
                  return (
                    <MenuItem key={key} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })
              : null}
          </TextField>
        );
      case 1:
        return (
          <TextField
            margin="normal"
            variant="outlined"
            className={classes.input}
            id="outlined-select-currency"
            select
            placeholder="Chọn số điện thoại"
            value={number}
            onChange={this.handleChange("number")}
            name="number"
            fullWidth>
            <MenuItem key={"random"} value={"random"}>
              Ngẫu nhiên
            </MenuItem>
            {listPhoneNumberResult
              ? listPhoneNumberResult.map((item, key) => {
                  return (
                    <MenuItem key={key} value={item.id}>
                      {item.id}
                    </MenuItem>
                  );
                })
              : null}
          </TextField>
        );
      case 2:
        return (
          <React.Fragment>
            <TextField
              margin="normal"
              variant="outlined"
              className={classes.input}
              id="outlined-select-currency"
              select
              placeholder="Lựa chọn option"
              value={agentAllocationType}
              onChange={this.handleChange("agentAllocationType")}
              name="agentAllocationType"
              fullWidth>
              <MenuItem key={"random"} value={"random"}>
                Phân bổ ngẫu nhiên
              </MenuItem>
              <MenuItem key={"agent"} value={"agent"}>
                Phân bổ 1 điện thoại viên
              </MenuItem>
              <MenuItem key={"equal"} value={"equal"}>
                Phân bổ đều cho điện thoại viên
              </MenuItem>
              <MenuItem key={"closest"} value={"closest"}>
                Phân bổ điện thoại viên chăm sóc gần nhất
              </MenuItem>
            </TextField>
            {this.state.agentAllocationType == "agent" ? (
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">Điện thoại viên</FormLabel>
                <RadioGroup
                  aria-label="Điện thoại viên"
                  name="value"
                  className={classes.group}
                  value={this.state.value}
                  onChange={this.handleChangeAgent("value")}>
                  {/* <Grid container>
                                            <Grid item md={6}> */}
                  {this.state.listAgentInCampaign &&
                  this.state.listAgentInCampaign.length != 0 ? (
                    this.state.listAgentInCampaign.map((item, key) => {
                      return (
                        <FormControlLabel
                          value={item.id}
                          key={key}
                          control={<Radio />}
                          label={`${item.code} - ${item.user.username}`}
                        />
                      );
                    })
                  ) : (
                    <React.Fragment />
                  )}
                  {/* </Grid>
                                        </Grid> */}
                </RadioGroup>
              </FormControl>
            ) : (
              <React.Fragment />
            )}
          </React.Fragment>
        );

      case 3:
        return (
          <React.Fragment>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.allowDuplicate}
                  onChange={this.handleChangeSwitch("allowDuplicate")}
                  value={allowDuplicate}
                  color="primary"
                />
              }
              label="Cho phép gọi trùng số điện thoại khách hàng"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.allowRecall}
                  onChange={this.handleChangeSwitchRecall("allowRecall")}
                  value={allowRecall}
                  color="primary"
                />
              }
              label="Gọi lại các khách hàng chưa tương tác"
            />
            <Typography>** Loại bỏ khách hàng có các trạng thái </Typography>
            <Grid container>
              {listStageResult
                ? listStageResult.map((item, key) => {
                    const check =
                      item.id === "ni" ? !this.state.stages.ni : null;
                    const checkDnd =
                      item.id === "dnd" ? !this.state.stages.dnd : null;
                    const c = check || checkDnd;
                    return (
                      <Grid item md={6} key={key}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={this.handleCheckStage(item.id)}
                              value={item.id}
                              name={item.name}
                              checked={this.state.stages[item.id]}
                            />
                          }
                          color="primary"
                          label={item.name}
                          disabled={!allowDuplicate}
                        />
                      </Grid>
                    );
                  })
                : null}
            </Grid>
          </React.Fragment>
        );
      // case 4:
      //     return (
      //         <React.Fragment>
      //             <Grid container>
      //                 <Typography>Chọn ngày</Typography>
      //                 {
      //                     dayValues.map(item => {
      //                         day = item + 1
      //                         if (day == 1) {
      //                             day = "Chủ nhật"
      //                         } else {
      //                             day = `Thứ ${day}`
      //                         }
      //                         return (
      //                             <Grid item md={6}>
      //                                 <FormControlLabel
      //                                     control={
      //                                         <Checkbox onChange={this.handleCheckStage(item)} value={item} name={item} checked={this.state.stages[item]} />
      //                                     }
      //                                     label={day}
      //                                 />
      //                             </Grid>
      //                         )
      //                     })
      //                 }
      //             </Grid>
      //         </React.Fragment>
      //     );
      case 4:
        return (
          <React.Fragment>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.checkForm}
                  onChange={this.handleChangeSwitch("checkForm")}
                  value={checkForm}
                  color="primary"
                />
              }
              label="Chọn mẫu kịch bản gọi ra"
            />
            {checkForm == true ? (
              <TextField
                margin="normal"
                variant="outlined"
                className={classes.input}
                id="outlined-select-currency"
                select
                label="Chọn kịch bản gọi ra"
                value={formId}
                onChange={this.handleChange("formId")}
                name="formId"
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth>
                {listFormTelesaleResult
                  ? listFormTelesaleResult.map((item, key) => {
                      return (
                        <MenuItem key={key} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })
                  : null}
              </TextField>
            ) : null}
          </React.Fragment>
        );
      case 5:
        if (this.props.campaigns === true) {
          return (
            <FormControl className={classes.formControl}>
              {/* <InputLabel htmlFor="select-multiple-chip">Chip</InputLabel> */}
              <Select
                multiple
                value={this.state.campaign}
                onChange={this.handleChangeCampaignIds}
                input={
                  <Input id="select-multiple-chip" style={{ width: 350 }} />
                }
                className={classes.input}
                style={{ width: 350 }}
                renderValue={(selected) => (
                  <div className={classes.chips}>
                    {selected
                      ? selected.map((value, key) => (
                          <Chip
                            key={key}
                            label={value.name}
                            className={classes.chip}
                          />
                        ))
                      : null}
                  </div>
                )}
                MenuProps={MenuProps}>
                {listCampaignResult
                  ? listCampaignResult.map((item, key) => {
                      return (
                        <MenuItem
                          key={key}
                          value={item}
                          style={getStyles(item.name, this)}>
                          {item.name}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
            </FormControl>
          );
        } else {
          return (
            <ValidatorForm
              ref="form"
              onSubmit={this.handleSubmit}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <TextValidator
                  margin="normal"
                  variant="outlined"
                  className={classes.input}
                  id="outlined-select-currency"
                  label="Số lượng"
                  value={this.state.limit}
                  onChange={this.handleChange("limit")}
                  name="limit"
                  fullWidth
                  validators={["required", "minNumber:1", "maxNumber:1000"]}
                  errorMessages={[
                    `Không được để trống`,
                    "Số lớn hơn 1",
                    "Số nhỏ hơn 1000",
                  ]}
                />
              </FormControl>
            </ValidatorForm>
          );
        }
      default:
        return "Unknown step";
    }
  };
  render() {
    const { activeStep, checkSelect } = this.state;
    const { classes, campaigns, newCampaign } = this.props;
    let steps;
    campaigns == true
      ? (steps = [
          "Chọn chiến dịch",
          "Chọn đầu số điện thoại gọi ra",
          "Chọn chế độ phân bổ cho điện thoại viên",
          "Chọn trạng thái khách hàng",
          "Chọn mẫu dữ liệu",
          "Chọn chiến dịch sẽ lấy dữ liệu",
        ])
      : this.props.limit !== true
      ? (steps = [
          "Chọn chiến dịch",
          "Chọn đầu số điện thoại gọi ra",
          "Chọn chế độ phân bổ cho điện thoại viên",
          "Chọn trạng thái khách hàng",
          "Chọn mẫu dữ liệu",
        ])
      : (steps = [
          "Chọn chiến dịch",
          "Chọn đầu số điện thoại gọi ra",
          "Chọn chế độ phân bổ cho điện thoại viên",
          "Chọn trạng thái khách hàng",
          "Chọn mẫu dữ liệu",
          "Chọn số lượng dữ liệu",
        ]);
    return (
      <React.Fragment>
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          title={"Phân bổ chiến dịch"}
          maxWidth={"md"}
          input={
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                  <StepContent>
                    {this.getStepContent(index)}
                    <Divider />
                    <div className={classes.actionsContainer}>
                      <Button
                        disabled={activeStep === 0}
                        onClick={this.handleBack}
                        className={classes.button}
                        color="secondary">
                        Quay lại
                      </Button>

                      {activeStep === steps.length - 1 ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.handleSubmit}
                          className={classes.button}
                          disabled={checkSelect}>
                          Hoàn tất thiết lập
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.handleNext}
                          className={classes.button}
                          disabled={activeStep === 3 ? false : checkSelect}>
                          Tiếp theo
                        </Button>
                      )}
                    </div>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          }
        />
        <Snackbar
          open={this.props.openModal}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          onClose={this.handleClose.bind(this)}
          autoHideDuration={3000}>
          <SnackbarContent
            onClose={this.handleClose.bind(this)}
            variant={"success"}
            message={`Phân bổ thành công ${
              newCampaign !== undefined ? newCampaign.interacticeLogCount : 0
            } tương tác`}
          />
        </Snackbar>
      </React.Fragment>
    );
  }
}

CampaignDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listCampaign: state.campaign.allCampaign,
  listFormTelesale: state.form.forms,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
  listStage: state.stage.stages,
  newCampaign: state.campaign.newCampaign,
  openModal: state.campaign.openModal,
  listAgents: state.agent.agents,
  loading: state.agent.loading,
});

const Form = connect(null, formAction)(CampaignDialog);
const PhoneNumber = connect(null, phoneNumberAction)(Form);
const Stage = connect(null, stageAction)(PhoneNumber);
const Agent = connect(null, AgentAction)(Stage);
CampaignDialog = connect(mapStateToProps, mapActionsToProps)(Agent);

export default withStyles(styles, { withTheme: true })(CampaignDialog);
